<template>
  <v-card>
    <BaseLoader v-if="loadingAdminComparateurMargeByGraine || loading" />

    <div
      v-else
      class="pa-2"
    >
      <div class="d-flex justify-space-between">
        <v-card-title
          class="px-2 align-self-center secondary--text text-h6 text-md-subtitle-1 font-weight-bold"
        >
          {{ libelleGraine }}
        </v-card-title>
      </div>
      <v-row
        no-gutters
        class="pa-1"
      >
        <v-col cols="2">
          <v-card
            elevation="0"
            class="eq-height mx-1 card-outter background"
          >
            <div class="d-flex justify-space-between pl-2">
              <div class="align-self-center secondary--text text-h6 text-md-subtitle-1">
                Produits
              </div>
              <v-dialog
                v-model="isOpenProduitModal"
                transition="slide-x-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="openProduitParametre"
                  >
                    <v-icon color="grey darken-2">
                      mdi-pencil-outline
                    </v-icon>
                  </v-btn>
                </template>
                <UpdateProduitModal
                  v-if="isOpenProduitModal"
                  :produits="produits"
                  class="custom-dialog"
                  @updateParametre="isAjoutParametreOpen = true"
                  @close="isOpenProduitModal = false"
                  @updatedParametre="updatedParametre"
                />
              </v-dialog>
            </div>
            <div
              v-for="(produit, index) in produits"
              :key="index"
              class="d-flex justify-space-between px-2"
            >
              <div
                v-if="!(produit.typeRubrique.statut !== 'OBLIGATOIRE' && produit.valeurDefaut == null)"
                class="align-self-center texte py-0 texte-gris-fonce"
              >
                <span v-if="isMaisGrainOuSorgo && produit.typeRubrique.libelleSousRubrique === 'Rendement'">Rendement sec</span>
                <span v-else-if="isMaisGrainOuSorgo && produit.typeRubrique.libelleSousRubrique === 'Prix de vente'">Prix net de frais de séchage</span>
                <span v-else>{{ produit.typeRubrique.libelleSousRubrique }}</span>
              </div>
              <div
                v-if="!(produit.typeRubrique.statut !== 'OBLIGATOIRE' && produit.valeurDefaut == null)"
                class="align-self-center texte py-0 secondary--text"
              >
                {{ produit.valeurDefaut!= null ? produit.valeurDefaut : '-' }} {{ produit.typeRubrique.libelleSousRubrique !== 'Rendement' ? produit.unite : uniteRendement }}
              </div>
            </div>
            <v-card-actions
              class="card-bottom d-flex justify-space-between pa-1 px-2"
            >
              <div class="action texte-gris-fonce">
                Total produits
              </div>
              <div class="action secondary--text">
                {{ produitTotal | roundNumber(2) }} €/ha
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            elevation="0"
            class="eq-height mx-1 card-outter background"
          >
            <div class="d-flex justify-space-between pl-2">
              <div class="align-self-center secondary--text text-h6 text-md-subtitle-1 mt-1">
                Itinéraire technique
              </div>
            </div>
            <v-row
              no-gutters
              class="mb-2"
            >
              <v-col
                class="px-1"
                cols="4"
              >
                <v-card
                  elevation="0"
                  class="card-outter background border px-2 pb-2 eq-height"
                >
                  <div class="d-flex justify-space-between mb-1">
                    <div class="align-self-center texte py-0 secondary--text">
                      Semences
                    </div>
                    <v-dialog
                      v-model="isOpenDensiteSemisModal"
                      transition="slide-x-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="openDensiteSemisModal"
                        >
                          <v-icon color="grey darken-2">
                            mdi-pencil-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <UpdateDensiteSemisModal
                        v-if="isOpenDensiteSemisModal"
                        :densite-semis="densiteSemis"
                        class="custom-dialog"
                        @updateParametre="isAjoutParametreOpen = true"
                        @updatedParametre="updatedParametre"
                        @close="isOpenDensiteSemisModal = false"
                      />
                    </v-dialog>
                  </div>
                  <div class="d-flex justify-space-between">
                    <div class="align-self-center texte py-0 texte-gris-fonce">
                      Densité de semis
                    </div>
                    <div class="texte py-0 secondary--text">
                      {{ densiteSemis.valeurEconomique != null ? densiteSemis.valeurEconomique : '-' }} €/ha
                    </div>
                  </div>
                  <v-card-actions
                    class="card-bottom d-flex justify-space-between pa-1 px-2"
                  >
                    <div class="action texte-gris-fonce">
                      Total semences
                    </div>
                    <div class="action secondary--text">
                      {{ semenceTotal | roundNumber(2) }} €/ha
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col
                class="px-1"
                cols="4"
              >
                <v-card
                  elevation="0"
                  class="card-outter background border px-2 pb-2 eq-height"
                >
                  <div class="pb-10">
                    <div class="d-flex justify-space-between mb-1">
                      <div class="align-self-center texte py-0 secondary--text">
                        Engrais
                      </div>
                      <v-dialog
                        v-model="isOpenEngraisModal"
                        transition="slide-x-transition"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="openEngraisModal"
                          >
                            <v-icon color="grey darken-2">
                              mdi-pencil-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <UpdateEngraisModal
                          v-if="isOpenEngraisModal"
                          :engrais="engrais"
                          class="custom-dialog"
                          @updateParametre="isAjoutParametreOpen = true"
                          @updatedParametre="updatedParametre"
                          @close="isOpenEngraisModal = false"
                        />
                      </v-dialog>
                    </div>
                    <div
                      v-for="uneEngrais in engrais"
                      :key="uneEngrais.id"
                      class="d-flex texte justify-space-between texte py-0 "
                    >
                      <span
                        v-if="!(uneEngrais.typeRubrique.statut !== 'OBLIGATOIRE' && uneEngrais.valeurEconomiqueEngrais == null && uneEngrais.valeurEconomique == null )"
                        class="texte-gris-fonce"
                      >{{ uneEngrais.typeRubrique.libelleSousRubrique }}</span>
                      <span
                        v-if="!(uneEngrais.typeRubrique.statut !== 'OBLIGATOIRE' && uneEngrais.valeurEconomiqueEngrais == null && uneEngrais.valeurEconomique == null )"
                        class="secondary--text"
                      >{{ uneEngrais.typeRubrique.isValeurEconomiqueUniquement ? uneEngrais.valeurEconomique != null ? uneEngrais.valeurEconomique : '-' : uneEngrais.valeurEconomiqueEngrais != null ? uneEngrais.valeurEconomiqueEngrais : '-' }} €/ha</span>
                    </div>
                  </div>
                  <v-card-actions
                    class="card-bottom d-flex justify-space-between pa-1 px-2"
                  >
                    <div class="action texte-gris-fonce">
                      Total engrais
                    </div>
                    <div class="action secondary--text">
                      {{ engraisTotal | roundNumber(2) }} €/ha
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col
                class="px-1"
                cols="4"
              >
                <v-card
                  elevation="0"
                  class="card-outter background border px-2 pb-2 eq-height"
                >
                  <div class="d-flex justify-space-between  mb-1">
                    <div class="align-self-center texte py-0 secondary--text">
                      Traitements
                    </div>
                    <v-dialog
                      v-model="isOpenTraitementModal"
                      transition="slide-x-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="openTraitementModal"
                        >
                          <v-icon color="grey darken-2">
                            mdi-pencil-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <UpdateTraitementModal
                        v-if="isOpenTraitementModal"
                        :traitements="traitements"
                        class="custom-dialog"
                        @updateParametre="isAjoutParametreOpen = true"
                        @updatedParametre="updatedParametre"
                        @close="isOpenTraitementModal = false"
                      />
                    </v-dialog>
                  </div>
                  <div class=" d-flex flex-column ">
                    <div
                      v-for="traitement in traitements"
                      :key="traitement.id"
                      class="d-flex texte justify-space-between texte py-0 "
                    >
                      <span
                        v-if="traitement.valeurEconomique!= null || traitement.pressionValeurDefaut != null || traitement.typeRubrique.statut === 'OBLIGATOIRE'"
                        class="texte-gris-fonce"
                      >{{ traitement.typeRubrique.libelleSousRubrique }}</span>
                      <span
                        v-if="traitement.valeurEconomique!= null || traitement.pressionValeurDefaut != null || traitement.typeRubrique.statut === 'OBLIGATOIRE'"
                        class="secondary--text"
                      >{{ traitement.typeRubrique.isValeurEconomiqueUniquement ? traitement.valeurEconomique!= null ? traitement.valeurEconomique : '-' : displayTraitementDefaut(traitement) }} €/ha</span>
                    </div>
                  </div>
                  <v-card-actions
                    class="card-bottom d-flex justify-space-between pa-1 px-2"
                  >
                    <div class="action texte-gris-fonce">
                      Total traitements
                    </div>
                    <div class="action secondary--text">
                      {{ traitementTotal | roundNumber(2) }} €/ha
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-card-actions
              class="card-bottom d-flex justify-space-between pa-1 px-2"
            >
              <div class="action texte-gris-fonce">
                Total intrants
              </div>
              <div class="action secondary--text">
                {{ intrantsTotal | roundNumber(2) }} €/ha
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card
            elevation="0"
            class="eq-height mx-1 card-outter background"
          >
            <div class="d-flex justify-space-between pl-2">
              <div class="align-self-center secondary--text text-h6 text-md-subtitle-1">
                Autres charges spécifiques
              </div>
              <div>
                <v-dialog
                  v-model="isOpenAutresChargesModal"
                  transition="slide-x-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="openAutresChargesModal"
                    >
                      <v-icon color="grey darken-2">
                        mdi-pencil-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <UpdateAutresChargesModal
                    v-if="isOpenAutresChargesModal"
                    :autres-charges="autresChargesSpecifiques"
                    class="custom-dialog"
                    @updateParametre="isAjoutParametreOpen = true"
                    @updatedParametre="updatedParametre"
                    @close="isOpenAutresChargesModal = false"
                  />
                </v-dialog>
              </div>
            </div>
            <div
              v-for="(autreChargeSpecifique, index) in autresChargesSpecifiques"
              :key="index"
              class="d-flex justify-space-between px-2"
            >
              <div
                v-if="!(autreChargeSpecifique.typeRubrique.statut !== 'OBLIGATOIRE' && autreChargeSpecifique.valeurDefaut == null)"
                class="align-self-center texte py-0 texte-gris-fonce"
              >
                {{ autreChargeSpecifique.typeRubrique.libelleSousRubrique }}
              </div>
              <div
                v-if="!(autreChargeSpecifique.typeRubrique.statut !== 'OBLIGATOIRE' && autreChargeSpecifique.valeurDefaut == null)"
                class="align-self-center texte py-0 secondary--text"
              >
                {{ autreChargeSpecifique.valeurDefaut != null ? autreChargeSpecifique.valeurDefaut : '-' }} {{ autreChargeSpecifique.unite }}
              </div>
            </div>
            <v-card-actions
              class="card-bottom d-flex justify-space-between pa-1 px-2"
            >
              <div class="action texte-gris-fonce">
                Total autres charges
              </div>
              <div class="action secondary--text">
                {{ autresChargesTotal | roundNumber(2) }} €/ha
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card
            elevation="0"
            class="eq-height mx-1 background"
          >
            <div class="d-flex justify-space-between pl-2">
              <div class="align-self-center secondary--text text-h6 text-md-subtitle-1">
                Indicateurs non chiffrés
              </div>
              <div>
                <v-dialog
                  v-model="isOpenIndicateursNonChiffresModal"
                  transition="slide-x-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="openIndicateursNonChiffresModal"
                    >
                      <v-icon color="grey darken-2">
                        mdi-pencil-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <UpdateIndicateursNonChiffresModal
                    v-if="isOpenIndicateursNonChiffresModal"
                    :indicateurs-non-chiffres="adminComparateurMargeByGraine.indicateursNonChiffres"
                    class="custom-dialog"
                    @updateParametre="isAjoutParametreOpen = true"
                    @updatedParametre="updatedParametre"
                    @close="isOpenIndicateursNonChiffresModal = false"
                  />
                </v-dialog>
              </div>
            </div>
            <div
              class="d-flex justify-space-between px-2"
            >
              <div class="align-self-center texte py-0 texte-gris-fonce">
                Restitution nutritive
              </div>
              <div
                class="align-self-center texte py-0 secondary--text"
              >
                {{ indicateursNonChiffresRestitutionNutritive.apportAzote ? indicateursNonChiffresRestitutionNutritive.apportAzote : '-' }}uN, {{ indicateursNonChiffresRestitutionNutritive.apportPhosphore ? indicateursNonChiffresRestitutionNutritive.apportPhosphore : '-' }}uP, {{ indicateursNonChiffresRestitutionNutritive.apportPotassium ? indicateursNonChiffresRestitutionNutritive.apportPotassium : '-' }}uK
              </div>
            </div>
            <div
              class="d-flex justify-space-between px-2"
            >
              <div class="align-self-center texte py-0 texte-gris-fonce">
                PAC
              </div>
              <div
                class="align-self-center texte py-0 secondary--text"
              >
                {{ indicateursNonChiffresPAC.nombrePointsPAC >= 0 ? indicateursNonChiffresPAC.nombrePointsPAC : '-' }} {{ indicateursNonChiffresPAC.nombrePointsPAC != null ? indicateursNonChiffresPAC.nombrePointsPAC > 1 ? 'points' : 'point' : '' }} {{ indicateursNonChiffresPAC.libellePAC ? '('+indicateursNonChiffresPAC.libellePAC +')' : '' }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog
        v-if="isAjoutParametreOpen"
        v-model="isAjoutParametreOpen"
        persistent
        width="500"
      >
        <NouveauParametreModal @close="isAjoutParametreOpen = false" />
      </v-dialog>
    </div>
    <v-card-actions
      class="d-flex pa-1 px-5"
    >
      <div class="texte-h6 font-weight-bold texte-gris-fonce mr-3">
        Marge brute
      </div>
      <div class="texte-h5 font-weight-bold secondary--text">
        {{ margeBrut | roundNumber(2) }} €/ha
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import NouveauParametreModal from './modal/update-parametre-modal.vue'
import UpdateProduitModal from './modal/update-produit-modal.vue'
import UpdateDensiteSemisModal from './modal/update-densite-semis-modal.vue'
import UpdateTraitementModal from './modal/update-traitement-modal.vue'
import UpdateEngraisModal from './modal/update-engrais-modal.vue'
import UpdateAutresChargesModal from './modal/update-autres-charges-modal.vue'
import UpdateIndicateursNonChiffresModal from './modal/update-indicateurs-non-chiffres-modal.vue'
import { sortBy } from 'lodash'

export default {
  name: 'CarteCulture',
  components: { BaseLoader, NouveauParametreModal, UpdateAutresChargesModal, UpdateEngraisModal, UpdateIndicateursNonChiffresModal, UpdateProduitModal, UpdateDensiteSemisModal, UpdateTraitementModal },
  props: {
    cultureId: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadingAdminComparateurMargeByGraine: false,
      erreur: false,
      isAjoutParametreOpen: false,
      isOpenProduitModal: false,
      isOpenDensiteSemisModal: false,
      isOpenEngraisModal: false,
      isOpenTraitementModal: false,
      isOpenAutresChargesModal: false,
      isOpenIndicateursNonChiffresModal: false,
      adminComparateurMargeByGraine: null,
      cultureIdSelected: null
    }
  },
  computed: {

    libelleGraine () {
      return this.adminComparateurMargeByGraine.typeCulture.nom
    },
    produits () {
      return sortBy(this.adminComparateurMargeByGraine.comparateurMargeParametres.filter(c => c.typeRubrique.codeRubrique === 'PRODUIT'), 'id')
    },
    densiteSemis () {
      return this.adminComparateurMargeByGraine.comparateurMargeParametres.filter(c => c.typeRubrique.codeRubrique === 'DENSITE_SEMIS')[0]
    },
    engrais () {
      return sortBy(this.adminComparateurMargeByGraine.comparateurMargeParametres.filter(c => c.typeRubrique.codeRubrique === 'ENGRAIS'), 'id')
    },
    traitements () {
      return sortBy(this.adminComparateurMargeByGraine.comparateurMargeParametres.filter(c => c.typeRubrique.codeRubrique === 'TRAITEMENT'), 'id')
    },
    autresChargesSpecifiques () {
      return sortBy(this.adminComparateurMargeByGraine.comparateurMargeParametres.filter(c => c.typeRubrique.codeRubrique === 'AUTRE_CHARGE_SPECIFIQUE'), 'id')
    },
    produitRendement () {
      return this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Rendement') != null ? this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Rendement').valeurDefaut : null
    },
    produitPrixDeVente () {
      return this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Prix de vente') != null ? this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Prix de vente').valeurDefaut : null
    },
    produitAidesCouplees () {
      return this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Aides couplées') != null ? this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Aides couplées').valeurDefaut : null
    },
    produitVentePaille () {
      return this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Vente paille') != null ? this.produits.find(p => p.typeRubrique.libelleSousRubrique === 'Vente paille').valeurDefaut : null
    },
    isLinFibre () {
      return this.adminComparateurMargeByGraine.typeCulture && (this.adminComparateurMargeByGraine.typeCulture.code === 'LFH' || this.adminComparateurMargeByGraine.typeCulture.code === 'LFP')
    },
    isMaisGrainOuSorgo () {
      return this.adminComparateurMargeByGraine.typeCulture && ((this.adminComparateurMargeByGraine.typeCulture.code === 'MG' || this.adminComparateurMargeByGraine.typeCulture.code === 'SGG'))
    },
    uniteRendement () {
      if (this.isLinFibre) {
        return 'kg/ha'
      } else if (this.adminComparateurMargeByGraine.typeCulture.isUniteAfficheeTonneParHectare) {
        return 't/ha'
      } else {
        return 'qx/ha'
      }
    },
    produitTotal () {
      return this.adminComparateurMargeByGraine.totalProduitCulture
    },
    intrantsTotal () {
      return this.adminComparateurMargeByGraine.totalIntrantsCulture
    },
    semenceTotal () {
      return this.adminComparateurMargeByGraine.totalSemences
    },
    engraisTotal () {
      return this.adminComparateurMargeByGraine.totalEngrais
    },
    traitementTotal () {
      return this.adminComparateurMargeByGraine.totalTraitements
    },
    autresChargesTotal () {
      return this.adminComparateurMargeByGraine.totalAutreChargeCulture
    },
    margeBrut () {
      return this.adminComparateurMargeByGraine ? this.adminComparateurMargeByGraine.margeBruteCulture : null
    },
    indicateursNonChiffresRestitutionNutritive () {
      return this.adminComparateurMargeByGraine.indicateursNonChiffres.restitutionNutritive
    },
    indicateursNonChiffresPAC () {
      return this.adminComparateurMargeByGraine.indicateursNonChiffres.indicateurNonChiffrePAC
    }
  },

  watch: {
    cultureIdSelected () {
      if (this.cultureIdSelected != null) {
        this.getAdminComparateurMargeByGraine(this.cultureIdSelected)
          .then((response) => {
            this.adminComparateurMargeByGraine = response
          })
          .finally(() => {
            this.cultureIdSelected = null
          })
      }
    }
  },

  created () {
    this.loadingAdminComparateurMargeByGraine = true
    this.getAdminComparateurMargeByGraine(this.cultureId)
      .then((response) => {
        this.adminComparateurMargeByGraine = response
    })
      .finally(() => {
      this.loadingAdminComparateurMargeByGraine = false
    })
  },

  methods: {
    ...mapActions({
      getAdminComparateurMargeByGraine: 'comparateurMarge/getAdminComparateurMargeByGraine'
    }),
    displayTraitementDefaut (traitement) {
      let result = null
      if (traitement.pressionValeurDefaut === 'Pression forte' && traitement.valeurMax != null) {
        result = traitement.valeurMax
      } else if (traitement.pressionValeurDefaut === 'Pression faible' && traitement.valeurMin != null) {
        result = traitement.valeurMin
      } else if (traitement.pressionValeurDefaut === 'Pression moyenne' && traitement.valeurDefaut != null) {
        result = traitement.valeurDefaut
      } else {
        result = '-'
      }
      return result
    },
    closeAllModale () {
      this.isOpenProduitModal = false
      this.isOpenDensiteSemisModal = false
      this.isOpenEngraisModal = false
      this.isOpenTraitementModal = false
      this.isOpenAutresChargesModal = false
      this.isOpenIndicateursNonChiffresModal = false
    },
    openProduitParametre () {
      this.closeAllModale()
      this.isOpenProduitModal = true
    },
    openDensiteSemisModal () {
      this.closeAllModale()
      this.isOpenDensiteSemisModal = true
    },
    openEngraisModal () {
      this.closeAllModale()
      this.isOpenEngraisModal = true
    },
    openTraitementModal () {
      this.closeAllModale()
      this.isOpenTraitementModal = true
    },
    openAutresChargesModal () {
      this.closeAllModale()
      this.isOpenAutresChargesModal = true
    },
    openIndicateursNonChiffresModal () {
      this.closeAllModale()
      this.isOpenIndicateursNonChiffresModal = true
    },
    updatedParametre (idCulture) {
      this.cultureIdSelected = idCulture
      this.$emit('updatedParametre', idCulture)
    }
  }
}
</script>

<style lang="scss" scoped>
  .background {
    background: #EFF0E1;
  }


  .card-outter {
    position: relative;
    padding-bottom: 30px;
  }

  .card-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #cfd05d;
  }

  .border {
    border: 1px solid #cfd05d;
  }

.custom-dialog {
  position: fixed;
  top: 0;
  height: 100%;
  overflow-y: auto;
  right: 0;
  width: 360px;
}

</style>
